/**
 * 命名规则全部常亮（此处全是被mutation提交的方法名称）
 */
export const ISLOGIN = 'ISLOGIN'
export const SET_TOKEN = 'SET_TOKEN'
export const STUDENT_DETAILSID = 'SET_ID'
export const WEBSOCKET_MSG = 'WEBSOCKET_MSG'
export const WEBSOCKET_CONNECT = 'WEBSOCKET_CONNECT'



// WEBPACK FOOTER //
// ./src/store/mutation-types.js